import { HttpParams } from "@angular/common/http";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AuthService } from "../../core/services/auth/auth.service";
import { CommonConfirmDialogComponent } from "../common-confirm-dialog/common-confirm-dialog.component";
import { Const } from "../../core/data/models/const";
import { MeterConfirmDialogInfo } from "../../core/data/models/meter-confirm-dialog-info";
import { CompanyModel } from "../site-management/site-management.component";
import { AlertMessage } from "src/app/core/constants/messages/alert-message";
import { CompanyApi } from "src/app/core/api/company.api";

@Component({
  selector: "app-company-add-edit-dialog",
  templateUrl: "./company-add-edit-dialog.component.html",
  styleUrls: ["./company-add-edit-dialog.component.scss"],
})
export class CompanyAddEditDialogComponent implements OnInit {
  idToken: string;
  companyName: string;

  @Input() public company: CompanyModel;
  constructor(
    public dialogRef: MatDialogRef<CompanyAddEditDialogComponent>,
    public confirmDialog: MatDialog,
    public dialog: MatDialog,
    public auth: AuthService,
    private companyApi: CompanyApi,
    @Inject(MAT_DIALOG_DATA) public isEditMode: boolean = false
  ) {}

  ngOnInit() {
    if (this.isEditMode) {
      this.companyName = this.company.name;
    }
  }

  onClickConfirm() {
    if (!navigator.onLine) {
      alert(AlertMessage.NET_ERROR_MESSAGE);
      return;
    }

    if (this.isEditMode) {
      this.updateCompany();
    } else {
      this.addCompany();
    }
  }

  addCompany() {
    const messageInfo = new MeterConfirmDialogInfo(
      "新規登録確認",
      "会社を新規登録します。よろしいですか。"
    );
    const confirmDialog = this.confirmDialog.open(
      CommonConfirmDialogComponent,
      {
        width: "400px",
        data: messageInfo,
      }
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === "Yes") {
        // 会社の登録処理
        let params = new HttpParams();
        params = params.set("name", this.companyName);
        this.companyApi.createCompany(params)
          .subscribe(
            (response) => {
              this.dialogRef.close("close");
            }
          );
      }
    });
  }

  updateCompany() {
    const messageInfo = new MeterConfirmDialogInfo(
      "会社更新確認",
      "会社を更新します。よろしいですか。"
    );
    const confirmDialog = this.confirmDialog.open(
      CommonConfirmDialogComponent,
      {
        width: "400px",
        data: messageInfo,
      }
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === "Yes") {
        // 会社更新処理
        let params = new HttpParams();
        params = params.set("name", this.companyName);
        this.companyApi.patchCompany(this.company.id, params)
          .subscribe(
            (response) => {
              this.dialogRef.close("close");
            }
          );
      }
    });
  }

  checkIfFormDirty() {
    return this.companyName != this.company.name;
  }

  checkIfFormReady() {
    return (
      this.companyName != "" &&
      this.companyName != null &&
      this.companyName != undefined
    );
  }

  comfirmButtonDisable() {
    if (this.isEditMode) {
      return this.checkIfFormReady() && this.checkIfFormDirty();
    }
    return this.checkIfFormReady();
  }

  // ログアウト
  onClickLogout() {
    Const.release();
    this.auth.signOut();
  }
}
